// App — mounts the TanStack Router. The route tree is generated at build time
// by the Vite plugin (see `vite.config.ts`) from files in `src/routes/` and
// emitted to `src/routeTree.gen.ts`.

import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return <RouterProvider router={router} />;
}
